const DataBackup = () => import('Views/userCenter/data-backup');

export default [
  { path: '/data-backup', component: DataBackup },
];



// WEBPACK FOOTER //
// ./src/router/dataBackup.js